<div class="lightTheme">
  <div *ngIf="isLoader" class="svg-loader"></div>
  <div class="d-flex flex-row page-header">
    Pi Point
  </div>

  <div class="d-flex search_filter_area ">
    <div id="searchBar" class="d-inline-block">
      <input type="text" class="form-control" (keyup)="globalService.applyFilter($event.target.value, piPointList)" placeholder="Search">
      <span class="searchIcon"><mat-icon aria-hidden="false" aria-label="search">search</mat-icon></span>
    </div>
      <div class="col-8 col-sm-8 col-md-8 col-lg-8 regularText">
        <mat-chip-listbox #chipList>
          <mat-chip-option *ngFor="let element of selectedFilters" [removable]="true" (removed)="remove(element)">
            {{globalService.replaceDisplayText(element.selectedFieldName) + " " + element.selectedCondition + " " + element.selectedValue}}
            <mat-icon matChipRemove *ngIf="true">cancel</mat-icon>
          </mat-chip-option>
        </mat-chip-listbox>
      </div>
      <div class="tbl_head_action float-right">
        <span class="filterIcon" matTooltip="Add Filter" placement="left-top" [ngbPopover]="addFilter" #popOver="ngbPopover" popoverTitle="Add Filter" autoClose="outside" popoverClass="popClassWidth"></span>
        <span class="exportIcon" matTooltip="Export to Excel" (click)="exporterPiPoint.exportTable('xlsx', {fileName:'PiPoint', sheet: 'PiPoint'})"
        (keydown)="exporterPiPoint.exportTable('xlsx', {fileName:'PiPoint', sheet: 'PiPoint'})"></span>
      </div>
    </div>
    <div class="d-flex flex-column pipointTable">
      <mat-table matTableExporter [dataSource]="piPointList" matSort #exporterPiPoint="matTableExporter" hiddenColumns="[7]">
        <ng-container matColumnDef="tag">
          <mat-header-cell (click) = "onSortChange()" (keydown)="onSortChange()" *matHeaderCellDef mat-sort-header class="Header TitleMatEventID heading2">Tag</mat-header-cell>
          <mat-cell *matCellDef="let row" class="TitleMatEventID regularText">{{row.tag}}</mat-cell>
        </ng-container>
        <ng-container matColumnDef="locationName">
          <mat-header-cell (click) = "onSortChange()" (keydown)="onSortChange()" *matHeaderCellDef mat-sort-header class="Header TitleMatUnit heading2">Location</mat-header-cell>
          <mat-cell *matCellDef="let row" class="TitleMatUnit regularText">{{row.locationName}}</mat-cell>
        </ng-container>
        <ng-container matColumnDef="descriptor">
          <mat-header-cell (click) = "onSortChange()" (keydown)="onSortChange()" *matHeaderCellDef mat-sort-header class="Header ClsMatDescription heading2">
            Description
          </mat-header-cell>
          <mat-cell *matCellDef="let row" class="ClsMatDescription regularText" matTooltip={{row.descriptor}} matTooltipPosition="above" matTooltipclass="tooltip">
            {{((row.descriptor != null && row.descriptor.length > 45 ) ? row.descriptor.substring(0, 40) + "..." : row.descriptor)}}
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="engUnits">
          <mat-header-cell (click) = "onSortChange()" (keydown)="onSortChange()" *matHeaderCellDef mat-sort-header class="TitleMatEngunit heading2">Engineering Units</mat-header-cell>
          <mat-cell *matCellDef="let row" class="TitleMatEngunit regularText"> {{row.engUnits != null && row.engUnits}} </mat-cell>
        </ng-container>
        <ng-container matColumnDef="pointSource">
          <mat-header-cell (click) = "onSortChange()" (keydown)="onSortChange()" *matHeaderCellDef mat-sort-header class="TitleMatUnit heading2">Point Source</mat-header-cell>
          <mat-cell *matCellDef="let row" class="TitleMatUnit regularText"> {{row.pointSource}} </mat-cell>
        </ng-container>
        <ng-container matColumnDef="pointType">
          <mat-header-cell (click) = "onSortChange()" (keydown)="onSortChange()" *matHeaderCellDef mat-sort-header class="TitleMatUnit heading2">
           Point Type
          </mat-header-cell>
          <mat-cell *matCellDef="let row" class="TitleMatUnit regularText"> {{row.pointType}} </mat-cell>
        </ng-container>
        <ng-container matColumnDef="pointTypeX">
          <mat-header-cell (click) = "onSortChange()" (keydown)="onSortChange()" *matHeaderCellDef mat-sort-header class="TitleMatUnit heading2">
            Point Type X
          </mat-header-cell>
          <mat-cell *matCellDef="let row" class="TitleMatUnit regularText"> {{row.pointTypeX}} </mat-cell>
        </ng-container>
        <ng-container matColumnDef="Action">
          <mat-header-cell *matHeaderCellDef class="TitleMatAct heading2">
            Action
          </mat-header-cell>
          <mat-cell *matCellDef="let row" class="TitleMatAct regularText">
            <ng-container>
              <ng-container *ngIf="row.configured == 'No' && (globalService.hasTagAdminAccess() && globals.subscription == globals.subscription)">
                <a class="pointer pl-10" title="Add in Tag Master" (click)="configureTag(row)" style="color: #4585D0 ;">
                  <mat-icon>
                    add_circle
                  </mat-icon>
                </a>
              </ng-container>
              <ng-container *ngIf="row.configured == 'Yes'">
                <a class="pointer pl-10" title="Available in Tagmaster">
                  <mat-icon class="green-icon">
                    check_circle
                  </mat-icon>
                </a>
              </ng-container>
            </ng-container>
          </mat-cell>
        </ng-container>
        <mat-header-row *matHeaderRowDef="displayedColumns; sticky: true" class="column-height"></mat-header-row>
        <mat-row *matRowDef="let row; columns: displayedColumns;">
        </mat-row>
      </mat-table>
      <div *ngIf="(piPointList.data.length === 0) && (!isLoader)" class="emptyRepoMsg">
        <span> There are no records to display.</span>
      </div>
      <mat-paginator [hidden]="!piPointList.data.length" class="flex-wrap"
      [pageSizeOptions]="[10, 50, 75, 100]"
      [pageSize]="pageSize"
      [pageIndex]="pageIndex"
      (page)="onPageChange($event)"
      [length]="5000"
      ngClass="{{firstTableClass}}">
      </mat-paginator>
      <!--
      //NOSONAR
      <mat-paginator #piPointPaginator class="flex-wrap"
                 [pageSize]="10"
                 [pageSizeOptions]="[10, 50, 75, 100]" ngClass="{{firstTableClass}}">
  </mat-paginator>-->
    </div>
    <div class="clearfix"></div>
    <ng-template #addFilter><app-add-filter [filterList]="filterList" [application]="'piPoint'" [selectedFilters]="selectedFilters" (filterResponse)="filterResponse($event)"></app-add-filter></ng-template>
</div>
